export enum enumTypeOfInstruction {
  'Debit' = 1,
  'Credit',
  'No Amount Value',
  'Transfer'
}

export namespace enumTypeOfInstruction {
  export function values() {
    return Object.keys(enumTypeOfInstruction).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
